import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddFAQPageNew from "../../components/FAQ/AddFAQPageNew";



const AddFAQPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="FAQ" link2="/faq" title="Add FAQ" />

        {/* AddUserLayer */}
        <AddFAQPageNew />


      </MasterLayout>
    </>
  );
};

export default AddFAQPage;
